module.exports = __webpack_public_path__ + "static/media/contacts-invert.e55bfc13.svg";